import api from '.';

import { buildQueryWithParams, makeListTags } from '../../Utils/api';

const tagType = 'organization';

const organizationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    requestAllOrganizationsForUserId: builder.query({
      query: ({ id, filter }) => ({
        url: buildQueryWithParams(`users/${id}/organizations`),
        params: { filter }
      }),
      providesTags: makeListTags(tagType)
    }),
    requestAllOrganizations: builder.query({
      query: (filter) => ({
        url: buildQueryWithParams('/organizations'),
        params: filter
      }),

      providesTags: makeListTags(tagType)
    }),
    requestOrganizationUsers: builder.query({
      query: ({loggedInUserId, filter}) => ({
        url: buildQueryWithParams(`/organizations/${loggedInUserId}/users`),
        method:'GET',
        params: {filter}
      }),
      transformResponse: (res) => {
        return res;
      },
    }),
    requestOrganizationDetails: builder.query({
      query: ({ id, filter }) => ({
        url: buildQueryWithParams(`/organizations/${id}`),
        method: 'GET',
        params: { filter }
      }),
      transformResponse: (res) => {
        return res;
      }
    }),
    // New Route implemented
    createOrganization: builder.mutation({
      query: (props) => ({
        url: '/organizations',
        method: 'POST',
        body: props
      }),
      invalidatesTags: [tagType]
    }),
    updateOrganization: builder.mutation({
      query: ({ param, id }) => ({
        url: `/organizations/${id}`,
        method: 'PATCH',
        body: param
      }),
      transformResponse(res) {
        return res;
      },
      invalidatesTags: [tagType]
    }),

    deleteOrganization: builder.mutation({
      query: ({ id }) => ({
        url: `/organizations/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: [tagType]
    }),

    //   New routes here
    requestOrganizations: builder.query({
      query: (filter) => ({
        url: '/organization-type',
        method: 'GET',
        params: { filter }
      }),
      transformResponse(res) {
        return res[0]?.organizations;
      }
    }),
    requestAllProviders: builder.query({
      query: (filter) => ({
        url: '/organization-type',
        method: 'GET',
        params: { filter }
      }),
      transformResponse(res) {
        return { list: res[0]?.organizations };
      }
    }),
    requestOrganizationsAdmin: builder.query({
      query: ({ userId, filter }) => ({
        url: `users/${userId}/organizations`,
        method: 'GET',
        params: { filter }
      }),
      transformResponse(res) {
        return res;
      }
    }),
    updateParentOrganization: builder.query({
      query: ({ body, id, where }) => ({
        url: `/organizations/${id}/organizations?where=${JSON.stringify(where)}`,
        method: 'PATCH',
        params: body
      })
    }),
    updateOrganizationProperties: builder.mutation({
      query: ({ data, id, where }) => ({
        url: `organizations/${id}/organization-properties?where=${JSON.stringify(where)}`,
        method: 'PATCH',
        body: data
      })
    }),
    createOrganizationProperties: builder.mutation({
      query: ({ data, id }) => ({
        url: `organizations/${id}/organization-properties`,
        method: 'POST',
        body: data
      })
    }),
    createOrganizationAndRelationship: builder.mutation({
      query: ({ data, id }) => ({
        url: `organizations/${id}/organizations`,
        method: 'POST',
        body: data
      })
    }),
    updateOrganizationType: builder.mutation({
      query: ({ data, id }) => ({
        url: `organizations/${id}/`,
        method: 'PATCH',
        body: data
      })
    }),
    requestOrganizationsType: builder.query({
      query: () => ({
        url: `/organization-type`,
        method: 'GET'
      }),
      transformResponse(res) {
        return res;
      }
    }),
    createParentOrganizationLink: builder.mutation({
      query: ({ id, body }) => ({
        url: `/organizations/${id}/organization-parent-organizations`,
        method: 'POST',
        body: body
      })
    }),
    deleteParentOrganizationLink: builder.mutation({
      query: ({ where, id }) => ({
        url: `/organizations/${id}/organization-parent-organizations?where=${JSON.stringify(
          where
        )}`,
        method: 'DELETE'
      })
    }),
    checkUserOrganizationAccess: builder.query({
      query: ({ organizationId, filter }) => ({
        url: `/organizations/${organizationId}/user-organization-roles`,
        method: 'GET',
        params: { filter }
      })
    })
  })
});

export default organizationsApi;
export const {
  useCreateParentOrganizationLinkMutation,
  useDeleteParentOrganizationLinkMutation,
  useRequestOrganizationsTypeQuery,
  useCreateOrganizationAndRelationshipMutation,
  useCreateOrganizationPropertiesMutation,
  useUpdateOrganizationPropertiesMutation,
  useLazyRequestOrganizationsAdminQuery,
  useLazyRequestOrganizationsQuery,
  useRequestAllOrganizationsForUserIdQuery,
  useDeleteOrganizationMutation,
  useRequestAllOrganizationsQuery,
  useRequestOrganizationDetailsQuery,
  useUpdateOrganizationMutation,
  useCreateOrganizationMutation,
  useCheckUserOrganizationAccessQuery,
  useLazyCheckUserOrganizationAccessQuery
} = organizationsApi;
